import _merge from 'lodash/merge'
import type { FavoritableItem } from "src/types/types";
import type { FilterAndSortOptions } from "src/state/redux/selector/common";

export const merge: (
  ...args: (FilterAndSortOptions<FavoritableItem> | null | undefined)[]
) => FilterAndSortOptions<FavoritableItem> = (...args) => _merge({}, ...args.filter(arg => arg))

const sortByIsFavorited = {
  sort: [{ meta: { isFavorite: 'asc' } }]
} satisfies FilterAndSortOptions<FavoritableItem>

const sortByTitle = (dir?: 'asc' | 'desc') => (
  {
    sort: [{ meta: { title: dir } }]
  }
) satisfies FilterAndSortOptions<FavoritableItem>

const sortByCreatedAt = (dir?: 'asc' | 'desc') => (
  {
    sort: [{ meta: { createdAt: dir } }]
  }
) satisfies FilterAndSortOptions<FavoritableItem>

const sortByUpdatedAt = (dir?: 'asc' | 'desc') => (
  {
    sort: [{ meta: { updatedAt: dir } }]
  }
) satisfies FilterAndSortOptions<FavoritableItem>

const sortByFavoritedTitle = (dir?: 'asc' | 'desc') => ({
  sort: [
    ...sortByIsFavorited.sort,
    ...sortByTitle(dir).sort,
  ]
}) satisfies FilterAndSortOptions<FavoritableItem>

const sortByFavoritedCreatedAt = (dir?: 'asc' | 'desc') => ({
  sort: [
    ...sortByIsFavorited.sort,
    ...sortByCreatedAt(dir).sort,
  ]
}) satisfies FilterAndSortOptions<FavoritableItem>

const sortByFavoritedUpdatedAt = (dir?: 'asc' | 'desc') => ({
  sort: [
    ...sortByIsFavorited.sort,
    ...sortByUpdatedAt(dir).sort,
  ]
}) satisfies FilterAndSortOptions<FavoritableItem>

export const sorts = {
  sortByIsFavorited,
  sortByTitle,
  sortByCreatedAt,
  sortByUpdatedAt,
  sortByFavoritedTitle,
  sortByFavoritedCreatedAt,
  sortByFavoritedUpdatedAt,
} satisfies Record<
  string,
  (
    | ((dir?: 'asc' | 'desc') => FilterAndSortOptions<FavoritableItem>)
    | FilterAndSortOptions<FavoritableItem>
  )
>
